import withPrivateRoute from '@/shared/lib/withPrivateRoute';
import { Dashboard } from '@/features/dashboard/ui/dashboard';
import LayoutContainer from '@/components/layout/layoutContainer';
import HeaderPage from '@/components/ui/custom/HeaderPage';

function DashboardPage() {
  return (
    <LayoutContainer>
      <HeaderPage
        title='Dashboard | GV Dashboard'
        content='GV Dashboard to manage your application.'
      />
      <Dashboard />
    </LayoutContainer>

  );
}

export default withPrivateRoute(DashboardPage);
